<template>
  <div
    class="modal custom-modal show"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    @click.self="
      $store.commit('layout/updateModal', {
        modal: 'help',
        show: false,
      })
    "
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <small style="color: #8A8A8A;">{{
              $store.state.layout.modal.help.subtitle
            }}</small>
            <h4>{{ $store.state.layout.modal.help.title }}</h4>
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="
              $store.commit('layout/updateModal', {
                modal: 'help',
                show: false,
              })
            "
          >
            <span aria-hidden="true">
              <icon-close
                :color="$store.state.layout.themeBlack ? '#fff' : '#000'"
              />
            </span>
          </button>
        </div>
        <div class="modal-body">
          <p
            style="white-space: pre-line;word-wrap: break-word;font-family: inherit;"
          >
            {{ $store.state.layout.modal.help.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iclose from '@/components/icons/close'

export default {
  components: {
    'icon-close': iclose,
  },
}
</script>

<style lang="scss">
.custom-modal {
  background-color: rgba(#fff, 0.6);
  overflow-x: hidden;
  overflow-y: auto;
  display: block;
  padding-left: 0px;

  .modal-dialog {
    min-width: 640px !important;
    margin: 160px auto;

    .modal-content {
      background-color: #252525;
      color: #fff;
      padding: 0 20px;
      font-size: 1rem;
      line-height: 1.5rem;
      border-radius: 20px;

      p {
        font-size: 1rem;
        line-height: 1.5rem;
      }
    }
    h2,
    h3,
    h4 {
      color: #fff;
      margin-bottom: 0;
    }
    .modal-header {
      border: none;
      padding-top: 20px;
      padding-bottom: 0;
    }

    .close {
      transform: translate(70px, -60px);
    }

    @media (max-width: 730px) {
      max-width: 100% !important;
      min-width: auto !important;

      .close {
        transform: translate(10px, -60px);
      }
    }
  }
}
</style>
